import React, { Component } from 'react';
import { connect } from "react-redux";
// import { Card } from '../../ui';
import Card from '@bit/xseed.ui-components.card';

import YatesWrapper from './Yates.style';
import Steps from '../../Steps';
import { setStepsList } from "../../../actions";
import { yates } from "../../../operations";

import Login from '../../Common/Login';
import Quotation from './Quotation';
import Payment from './Payment';
import YateForm_1 from './YateForm_1';
import YateForm_2 from './YateForm_2';
import YateForm_3 from './YateForm_3';
import YateForm_4 from './YateForm_4';

class Yates extends Component {

  constructor(props) {
    super(props);

    this.state = {
      globalSteps: ['1. Datos del yate', '2. Cotización', '3. Compra'],
      steps: [
        { pos: 0, global:  0, name: 'yateForm_1', backButton: false },
        { pos: 1, global:  0, name: 'yateForm_2' },
        { pos: 2, global:  1, name: 'quotation' },
        { pos: 3, global: -1, name: 'login' },
        { pos: 4, global:  2, name: 'yateForm_3' },
        { pos: 5, global:  2, name: 'yateForm_4' },
        { pos: 6, global:  2, name: 'payment' },
      ]
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { steps } = this.state;
    const { setStepsList, getDatosYates } = this.props;
    setStepsList(steps);
    getDatosYates();
  }

  getStepContent() {
    const { selectedStep } = this.props;
    switch (selectedStep.name) {
      case 'yateForm_1':
        return <YateForm_1 />;
      case 'yateForm_2':
        return <YateForm_2 />;
      case 'quotation':
        return <Quotation />;
      case 'login':
        return <Login />;
      case 'yateForm_3':
        return <YateForm_3 />;
      case 'yateForm_4':
        return <YateForm_4 />;
      case 'payment':
        return <Payment />;
    }
  }

  render() {

    const { globalSteps } = this.state;

    return (
      <Card className="Card--medium">
        <YatesWrapper>
          <Steps globalSteps={globalSteps} />
          <div>
            {this.getStepContent()}
          </div>
        </YatesWrapper>
      </Card>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.steps.isLoading,
    selectedStep: state.steps.selectedStep,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setStepsList: (steps) => {
      dispatch(setStepsList(steps));
    },
    getDatosYates: () => {
      dispatch(yates.getDatosYates());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Yates);